import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { cyan, transition } from './neonUtil'
import { DOT_PREFIX } from './constant'

export default genComponentStyleHook(['Tag', 'cyberTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      transition,
      borderRadius: 2,
      border: `1px solid ${cyan[500]}30`,
      background: `${cyan[500]}0a`,
      color: cyan[300],
      letterSpacing: '0.3px',
      fontSize: '12px',

      '&:hover': {
        borderColor: `${cyan[500]}60`,
        boxShadow: `0 0 6px ${cyan[500]}20`,
      },

      // 关闭图标
      [`${componentCls}-close-icon`]: {
        color: `${cyan[600]} !important`,
        '&:hover': {
          color: `${cyan[400]} !important`,
        },
      },
    },
  }
})
